interface VersionInfoProps {
  className?: string;
  showDetails?: boolean;
}

/**
 * Version information component that displays the current app version.
 * Can optionally show additional build details.
 */
export function VersionInfo({ className = '', showDetails = false }: VersionInfoProps) {
  const version = import.meta.env.VITE_APP_VERSION || 'dev';
  const buildTime = import.meta.env.VITE_BUILD_TIME;
  const commitSha = import.meta.env.VITE_COMMIT_SHA;

  return (
    <div className={`text-white/40 text-xs ${className}`}>
      <span className="font-mono">v{version}</span>
      {showDetails && (buildTime || commitSha) && (
        <span className="ml-2">
          {buildTime && <span className="text-white/30">• {buildTime}</span>}
          {commitSha && <span className="text-white/30 ml-1">• {commitSha.substring(0, 7)}</span>}
        </span>
      )}
    </div>
  );
}
